import { docStatuses } from "src/api/config/systemSwitch";

const COLORS = {
  green: "#22AD5C",
  blue: "#00629B",
  gray: "#D1D5DB",
  lightGray: "#DFE4EA",
  red: "#BA0C2F",
  yellow: "#F2A900",
};

export const getStatusIdMobile = (value: any): number | undefined => {
  if (value == null) return undefined;
  if (typeof value === "number") return value;
  if (typeof value === "string") {
    const num = Number(value);
    return Number.isFinite(num) ? num : undefined;
  }
  if (typeof value.get_lookupId === "function") return value.get_lookupId();
  if (typeof value.ID === "number") return value.ID;
  if (typeof value.Id === "number") return value.Id;
  if (typeof value.id === "number") return value.id;
  return undefined;
};

const hasStatus = (statuses: any[], statusId: number) =>
  Array.isArray(statuses) &&
  statuses.some((item: any) => getStatusIdMobile(item) === statusId);

export const getHistoryTimelineColorMobile = (statuses: any[] = []) => {
  if (hasStatus(statuses, docStatuses.cancel)) return COLORS.red;
  if (hasStatus(statuses, docStatuses.sendRevision)) return COLORS.red;
  if (
    hasStatus(statuses, docStatuses.agreed) ||
    hasStatus(statuses, docStatuses.approved) ||
    hasStatus(statuses, docStatuses.public)
  ) {
    return COLORS.green;
  }
  if (
    hasStatus(statuses, docStatuses.waitApproval) ||
    hasStatus(statuses, docStatuses.review)
  ) {
    return COLORS.yellow;
  }
  if (
    hasStatus(statuses, docStatuses.sendApproval) ||
    hasStatus(statuses, docStatuses.edited)
  ) {
    return COLORS.blue;
  }
  if (hasStatus(statuses, docStatuses.sendArchive)) return COLORS.gray;
  return COLORS.lightGray;
};

export const getVersionTimelineColorMobile = (statusId?: number) => {
  if (statusId === docStatuses.actual) return COLORS.green;
  if (
    statusId === docStatuses.draft ||
    statusId === docStatuses.notPublic
  ) {
    return COLORS.blue;
  }
  if (
    statusId === docStatuses.notActual ||
    statusId === docStatuses.archive
  ) {
    return COLORS.gray;
  }
  if (statusId === docStatuses.cancel) return COLORS.red;
  if (statusId === docStatuses.review) return COLORS.yellow;
  return COLORS.lightGray;
};

